"use client";
import {
  createItemJson,
  deleteItem,
  fetchData,
  fetchDataNoPag,
  getOneItem,
  updateItemJson,
} from "../../../../Api/hotelEndpoint";
import { createAsyncThunk } from "@reduxjs/toolkit";

/***------------- Get All RoomCategory Data ------------- ***/
export const fetchRoomCategory = createAsyncThunk(
  "hotel/room-category/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      const { data, totalPages, totalItems } = await fetchData({
        endpoint: "hotel/room-category/fetchAll",
        ...params,
      });
      return { data, totalPages, totalItems };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Get All Room Category Name ------------- ***/
export const fetchRoomCategoryNoPage = async () => {
  try {
    const data = await fetchDataNoPag({
      endpoint: "fetchAllRoomCategory",
      paginate: false,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

/***------------- Get One RoomCategory Data ------------- ***/
export const fetchOneRoomCategory = createAsyncThunk(
  "hotel/room-category/fetch",
  async ({ id }, { rejectWithValue }) => {
    try {
      const data = await getOneItem(`hotel/room-category/fetch/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Add RoomCategory - API ------------- ***/
export const createRoomCategory = createAsyncThunk(
  "hotel/room-category/create",
  async ({ formData, router }, { rejectWithValue }) => {
    try {
      const data = await createItemJson({
        endpoint: "hotel/room-category/create",
        formData,
      });
      if (data) {
        router.push("/hotel/room-category");
        return data;
      } else throw new Error("Request failed");
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/***------------- update RoomCategory - API ------------- ***/
export const updateRoomCategory = createAsyncThunk(
  "hotel/room-category/update",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const data = await updateItemJson({
        endpoint: "hotel/room-category/update",
        formData,
        id: formData._id,
      });
      if (data) return { id: formData._id, data };
      else throw new Error("Request failed");
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/***------------- Delete RoomCategory - API ------------- ***/
export const deleteRoomCategory = createAsyncThunk(
  "hotel/room-category/delete",
  async (deleteData, { rejectWithValue }) => {
    try {
      const data = await deleteItem({
        endpoint: "hotel/room-category",
        ...deleteData,
      });
      if (data) return data?.id;
      else throw new Error("Request failed");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Delete-undo RoomCategory - API ------------- ***/
export const deleteUndoRoomCategory = createAsyncThunk(
  "hotel/room-category/delete-undo",
  async (deleteData, { rejectWithValue }) => {
    try {
      const data = await deleteItem({
        endpoint: "hotel/room-category",
        ...deleteData,
        undo: true,
      });
      if (data) return data?.id;
      else throw new Error("Request failed");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
